export default __webpack_public_path__ + "static/180-1494f7fc8c40078d9a1f103574204b7e.jpg";